import Vuex from 'vuex';
import Vue from 'vue';
import { FORM_BUILDER_NAMESPACE } from './modules/form-builder/form-builder.constants.js';
export { ADD_FIELD_TO_STATE, FORM_BUILDER_NAMESPACE, RESET_STATE, SET_FIELD } from './modules/form-builder/form-builder.constants.js';
import { formBuilder } from './modules/form-builder/form-builder.store.js';
export { actions, formBuilder, getters } from './modules/form-builder/form-builder.store.js';

var _a;
Vue.use(Vuex);
var store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: (_a = {},
        _a[FORM_BUILDER_NAMESPACE] = formBuilder,
        _a),
});

export { store };
